module.exports = __webpack_public_path__ + "img/vehicle_orange.87f5cdbf.svg";